import Handlebars from "../handlebars/handlebars";
import errorResponseHandler from "../errors/errorResponseHandler";
import duplicateItemHtml from "./duplicateItem.hbs"
import orderItemService from "../_services/orderItemService";

const CONFIRM_ACTION = '.js-action--confirm' ;
const CANCEL_ACTION = '.js-action--cancel';
const JOB_NAME = '.js-element--jobName';
const INCLUDE_COMPANIONS = '.js-element--includeCompanions';
class DuplicateItemController {
    constructor (modalInstance, container, currentItem) {
        this.state = {
            loading: false,
            currentItem: currentItem,
            name: currentItem.name,
        };

        this.modalInstance = modalInstance;
        this.container = container;
        this.template = duplicateItemHtml;

        this.handleClick = this.handleClick.bind(this);
        this.disableLoadingState = this.disableLoadingState.bind(this);

        this.enableUI()
        this.render()
    }

    enableUI () {
        this.container.addEventListener('click', this.handleClick, false);
        this.container.addEventListener('keydown', this.handleKeyDown.bind(this));
    }

    render () {
        this.container.innerHTML = this.template(this.state);
    }

    handleClick (e) {
        if (e.target.matches(CONFIRM_ACTION)) {
            this.handleDuplicateItem(e);
        }
        if (e.target.matches(CANCEL_ACTION)) {
            e.preventDefault();
            this.modalInstance.cancel();
        }
    }

    handleKeyDown (e) {
        if (e.target.matches('.js-element--jobName')) {
            switch(e.key) {
                case 'Enter':
                case 'NumpadEnter':
                    e.stopPropagation();
                    this.handleDuplicateItem(e);
                    break;
            }
        }
    }

    handleDuplicateItem (e) {
        const name = document.querySelector(JOB_NAME).value;
        this.state.name = name;

        // Only relevant when the item has companions; the checkbox is absent otherwise.
        const includeCompanionsEl = document.querySelector(INCLUDE_COMPANIONS);
        const includeCompanions = includeCompanionsEl ? includeCompanionsEl.checked : true;

        e.preventDefault();
        this.enableLoadingState();

        return orderItemService.duplicateItem(this.state.currentItem, { name, includeCompanions })
            .then(this.modalInstance.close)
            .catch(errorResponseHandler.generateErrorHandler())
            .finally(this.disableLoadingState)
    }

    enableLoadingState () {
        this.state.loading = true;
        this.render();
    }

    disableLoadingState (cart) {
        this.state.loading = false;
        this.render();
        return cart;
    }
}

export default DuplicateItemController;